document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('stores_edit');
  if (form == null) {
    return;
  }

  const holidayCheckboxes = document.querySelectorAll<HTMLInputElement>('.holiday-checkbox');
  const dayOfWeeks: dayOfWeeks[] = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
  type dayOfWeeks = 'sunday' | 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday';

  const dayOfWeeksJP = {'sunday': '日', 'monday': '月', 'tuesday': '火', 'wednesday': '水', 'thursday': '木', 'friday': '金', 'saturday': '土'}

  const preventEnterSubmit = () => {
    const inputs = document.querySelectorAll('input');
    [].forEach.call(inputs, input => {
      (input as HTMLInputElement).addEventListener('keydown', e => {
        if (e.which === 13 || e.keyCode === 13) {
          e.preventDefault();
          return false;
        } else {
          return true;
        }
      });
    });
  };

  const refreshBusinessTime = (dayOfWeek: dayOfWeeks, holidayCheckbox: HTMLInputElement) => {
    const openTime = document.querySelector<HTMLInputElement>(`#chirashiru_store_${dayOfWeek}_open_time`);
    const closeTime = document.querySelector<HTMLInputElement>(`#chirashiru_store_${dayOfWeek}_close_time`);
    if (!holidayCheckbox.checked) {
      if (openTime) {
        openTime.value = '09:00'
        openTime.disabled = false
      }
      if (closeTime) {
        closeTime.value = '21:00'
        closeTime.disabled = false
      }
    } else {
      if (openTime) {
        openTime.value = ''
        openTime.disabled = true
      }
      if (closeTime) {
        closeTime.value = ''
        closeTime.disabled = true
      }
    }
  }

  holidayCheckboxes.forEach((holidayCheckbox, index) => {
    holidayCheckbox.addEventListener('click', () => {
      refreshBusinessTime(dayOfWeeks[index], holidayCheckbox);
    })
  })

  const openingHourRegularHolidayConversion = () => {
    let conversionHash:{ [key: string]: string[] } = {} as any;

    dayOfWeeks.forEach(dayOfWeek => {
      const openTime = document.getElementById(`chirashiru_store_${dayOfWeek}_open_time`) as HTMLInputElement;
      const closeTime = document.getElementById(`chirashiru_store_${dayOfWeek}_close_time`) as HTMLInputElement;
      const regularHoliday = document.getElementById(`chirashiru_store_${dayOfWeek}_regular_holiday`) as HTMLInputElement;
      const businessHours = `${openTime.value}〜${closeTime.value}`;
      if (regularHoliday.checked) {
        conversionHash['regularHoliday'] = conversionHash['regularHoliday'] || [];
        conversionHash['regularHoliday'].push(dayOfWeeksJP[dayOfWeek]);
      } else {
        if (openTime.value == "" && closeTime.value == "") return
        conversionHash[businessHours] = conversionHash[businessHours] || [];
        conversionHash[businessHours].push(dayOfWeeksJP[dayOfWeek]);
      }
    })
    const businessHours = document.getElementById('chirashiru_store_business_hours') as HTMLInputElement;
    const businessHoursValue = [] as string[];
    Object.entries(conversionHash).forEach(([key, value]) => {
      if (key === 'regularHoliday') return
      businessHoursValue.push(`${value.join('、')}: ${key}`)
    })
    businessHours.value = businessHoursValue.join('、')
    const regularHoliday = document.getElementById('chirashiru_store_regular_holiday') as HTMLInputElement;
    regularHoliday.value = (conversionHash['regularHoliday'] || []).join('、')
  }

  const openingHourRegularHolidayConversionButton = document.querySelector<HTMLInputElement>('.opening-hour-regular-holiday-conversion button');
  if (openingHourRegularHolidayConversionButton) {
    openingHourRegularHolidayConversionButton.addEventListener('click', () => {
        openingHourRegularHolidayConversion();
    })
  }
  dayOfWeeks.forEach(dayOfWeek => {
    const openTimeId = document.getElementById(`chirashiru_store_${dayOfWeek}_open_time`) as HTMLInputElement;
    const closeTimeId = document.getElementById(`chirashiru_store_${dayOfWeek}_close_time`) as HTMLInputElement;
    console.log(openTimeId.value)
    if (openTimeId.value == '' || closeTimeId.value == '') {
      const checkbox = document.getElementById(`chirashiru_store_${dayOfWeek}_regular_holiday`) as HTMLInputElement;
      checkbox.checked = true;
      openTimeId.disabled = true;
      openTimeId.value = '';
      closeTimeId.disabled = true;
      closeTimeId.value = '';
    }
  })
  // 初期実行
  preventEnterSubmit();
})

